import { format, parseISO, isValid } from 'date-fns';

export const toIsoFromDateTimeParts = (date: string, time: string) => {
  const hasSlash = date.includes("/");
  let yyyy = "", mm = "", dd = "";

  if (hasSlash) {
    const [d, m, y] = date.split("/");
    dd = d; mm = m; yyyy = y;
  } else {
    const [y, m, d] = date.split("-");
    dd = d; mm = m; yyyy = y;
  }

  return `${yyyy}-${mm}-${dd}T${time}:00`;
};

export const extractDateTime = (dateString?: string | null, type: 'date' | 'time' = 'date') => {
  if (!dateString) return '';
  const normalizedString = dateString.replace(' ', 'T').replace(' -', '-').replace(' +', '+');
  const parsed = parseISO(normalizedString);
  if (!isValid(parsed)) return '';
  return type === 'date' ? format(parsed, 'dd/MM/yyyy') : format(parsed, 'HH:mm');
};